<template>
    <el-drawer
        :title="type == 1 ? '审核通过' : type == 2 ? '拒绝通过' : '直接更新'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <!-- <el-alert
                v-if="type == 3"
                title="如果修改的是次要信息，可以直接更新而不走线下寄送合同流程"
                type="warning"
                :closable="false">
            </el-alert> -->
            <el-alert
                v-if="type == 2"
                title="请在审核备注中写明原由"
                type="warning"
                :closable="false">
            </el-alert>
            <el-alert
                v-if="type == 1"
                title="如有其他需要说明的信息，请填写在审核备注中"
                type="warning"
                :closable="false">
            </el-alert>
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                class="MT20"
            >
                <!-- <template v-if="type != 2">
                    <el-form-item prop="contractSn" label="合同编号:">
                        <el-input
                            v-model="formData.contractSn"
                            placeholder="请输入合同编号"
                            size="medium"
                            maxlength="100"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="contractExpireTime" label="合同到期时间:">
                        <el-date-picker
                            v-model="formData.contractExpireTime"
                            type="datetime"
                            start-placeholder="合同到期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            size="medium">
                        </el-date-picker>
                    </el-form-item>
                </template> -->
                <el-form-item prop="remark" label="审核备注:" :rules="[{required: type == 2 ? true : false, message: '请在审核备注中写明原由'}]">
                    <el-input
                        v-model="formData.remark"
                        placeholder="请输入审核备注"
                        size="medium"
                        maxlength="100"
                        type="textarea"
                        :rows="2"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button :type="type == 2 ? 'danger' : 'primary'" @click="submitForm()" :loading="btnLoading">{{type == 1 ? '确认通过' : type == 2 ? '确认拒绝' : '确认直接更新'}}</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    contractExpireTime:'',
    contractSn:'',
    isPass:1,
    remark:'',
}
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules:{
                // contractSn:[{required: true, message: "请输入合同编号"}],
                // contractExpireTime:[{required: true, message: "请输入合同到期时间"}],
            },
            itemData: null,
            type:1 //1：审核通过，2：拒绝通过，3：直接更新
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data,type){
            this.formData = {
                ...defaultFormData,
                contractExpireTime: data.contractExpireTime || '',
                contractSn: data.contractSn || '',
            }
            this.type = type || 1,
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/raise/receivables/audit',
                        data: {...this.formData, id: this.id , isPass: this.type != 2 ? 1 : 2},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success("操作成功");
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>